import { format } from 'date-fns';
import { ConsiderationType } from 'further-types/exit';
import { ExitDetailsFormValues } from '../../ExitDetailsForm';
import { StagedShareholding } from '../../ExitDetailsForm/types';

type SharedShareConsiderationFields = {
  shareConsiderationCompanyId?: string;
  shareConsiderationShareClassId?: string;
  totalConsiderationShares?: number;
  shareConsiderationValuePerShare?: number;
  shareConsiderationValueTotal?: number;
  shareConsiderationEisEligible?: boolean;
  shareConsiderationAllocationMethod?: string;
  permitPartialShareAllocation?: boolean;
};

export type StageAmendmentForCorrectionInput = {
  exitId: string;
  exitAmendmentId: string;
  exitDate: string;
  firmId: string;
  sharePrice: number;
  taxableValueSharePrice: number;
  isReceivedValueSharePriceUnchanged: boolean;
  considerationType: string;
  maintainOriginalExitDetails: boolean;
} & SharedShareConsiderationFields;

export type Mutation = {
  mutate: (
    data: StageAmendmentForCorrectionInput,
    options: {
      onSuccess: (data: Array<StagedShareholding>) => void;
    },
  ) => void;
};

export const stageAmendmentForCorrection = (
  mutation: Mutation,
  exitId: string,
  exitAmendmentId: string,
  exitDetails: ExitDetailsFormValues,
  previousExitDetails: Partial<ExitDetailsFormValues>,
  sharedShareConsiderationFields: SharedShareConsiderationFields,
  maintainOriginalExitDetails: boolean,
  setInitialShareholdings: (data: Array<StagedShareholding>) => void,
) => {
  mutation.mutate(
    {
      exitId,
      exitAmendmentId,
      exitDate: format(exitDetails.exitDate, 'dd/MM/yyyy'),
      firmId: exitDetails.firmId,
      sharePrice: Number(exitDetails.sharePrice),
      taxableValueSharePrice: Number(exitDetails.taxableValueSharePrice),
      isReceivedValueSharePriceUnchanged:
        exitDetails.sharePrice === previousExitDetails?.sharePrice,
      considerationType:
        exitDetails.considerationType ?? ConsiderationType.Cash,
      maintainOriginalExitDetails,
      ...sharedShareConsiderationFields,
    },
    {
      onSuccess: (data: Array<StagedShareholding>) => {
        const formattedInitialShareholdingData = data?.map((sh) => ({
          ...sh,
          // Do NOT override investorTotalAccruedFees from the backend response
          // It contains the investment-level max for the limit display
          // totalAvailableAccruedFees is used separately for amendment correction cap logic
          previousGrossReceivedValue: sh.previousGrossReceivedValue,
        }));
        setInitialShareholdings(formattedInitialShareholdingData);
      },
    },
  );
};
